import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GraphQLResponse, ProtoApiService } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { FacilityUtilizationInput, FacilityUtilizationResponse } from '../../model/models';
import { FacilityUtilizationLegacyRequest } from './request/facility-utilization-legacy-request';
import { FacilityUtilizationLegacyResponse } from './response/facility-utilization-legacy-response';

@Injectable({ providedIn: 'root' })
export class GetFacilityUtilizationPayLater extends ProtoApiService<
    FacilityUtilizationLegacyRequest,
    FacilityUtilizationLegacyResponse
> {
    public requestType = FacilityUtilizationLegacyRequest;
    public responseType = FacilityUtilizationLegacyResponse;
    public endpointName: string;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
        this.endpointName = 'v1/query';
        this.serviceName = 'financingGql';
        this.usePascalForUrl = false;
    }

    public requestMapper(req: FacilityUtilizationLegacyRequest): { query: string } {
        const input: FacilityUtilizationInput = {
            companyFilter: {
                buyerIds: req.refBuyerKeys
            }
        };

        const query = jsonToGraphQLQuery({
            facilityUtilization: {
                __args: { input },
                payLater: {
                    limit: { cents: true, currencyCode: true },
                    utilized: { cents: true, currencyCode: true },
                    available: { cents: true, currencyCode: true }
                }
            }
        });
        return { query: `{${query}}` };
    }

    public responseMapper(
        res: GraphQLResponse<FacilityUtilizationResponse>
    ): FacilityUtilizationLegacyResponse {
        const { limit, utilized, available } = res?.data?.facilityUtilization?.payLater;
        return new FacilityUtilizationLegacyResponse({ ok: true, limit, utilized, available });
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
